export const TOOLS = [
  { slug: "whatsapp", name: "WhatsApp", color: "#25D366" },
  { slug: "email", name: "E-mail", color: "#F5B94A" },
  { slug: "www", name: "Sites & Domínios", color: "#3A9BFF" },
  { slug: "openclaw", name: "OpenClaw", color: "#FF5A36" },
  { slug: "hermes", name: "Hermes Agent", color: "#A78BFA" },
  { slug: "n8n", name: "n8n", color: "#EA4B71" },
  { slug: "claude", name: "Claude", color: "#D97757" },
  { slug: "openai", name: "ChatGPT", color: "#74AA9C" },
  { slug: "googlegemini", name: "Gemini", color: "#8E75B2" },
  { slug: "google", name: "Google", color: "#4285F4" },
  { slug: "instagram", name: "Instagram", color: "#FF0069" },
  { slug: "make", name: "Make", color: "#9B4DFF" },
  { slug: "zapier", name: "Zapier", color: "#FF4F00" },
  { slug: "telegram", name: "Telegram", color: "#26A5E4" },
  { slug: "youtube", name: "YouTube", color: "#FF0000" },
  { slug: "googleads", name: "Google Ads", color: "#4285F4" },
  { slug: "googlesheets", name: "Google Sheets", color: "#34A853" },
  { slug: "googlecalendar", name: "Google Agenda", color: "#4285F4" },
  { slug: "gmail", name: "Gmail", color: "#EA4335" },
  { slug: "meta", name: "Meta Ads", color: "#1D8DFF" },
  { slug: "facebook", name: "Facebook", color: "#0866FF" },
  { slug: "linkedin", name: "LinkedIn", color: "#0A66C2" },
  { slug: "tiktok", name: "TikTok", color: "#69C9D0" },
  { slug: "hubspot", name: "HubSpot", color: "#FF7A59" },
  { slug: "slack", name: "Slack", color: "#E01E5A" },
  { slug: "stripe", name: "Stripe", color: "#635BFF" },
  { slug: "mercadopago", name: "Mercado Pago", color: "#00B1EA" },
  { slug: "supabase", name: "Supabase", color: "#3FCF8E" },
  { slug: "wordpress", name: "WordPress", color: "#21759B" },
  { slug: "shopify", name: "Shopify", color: "#7AB55C" },
];

export const HERO_TOOLS = TOOLS.slice(0, 15);
